import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class ContentData {
  private _api = inject(FsApi);


  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'contents', data, { key: 'contentWidgets', ...config });
  }

  public put(contentWidget, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`contents/${contentWidget.id}`, contentWidget, { key: 'contentWidget', ...config });
  }

  public post(contentWidget): Observable<any> {
    return this._api.post('contents', contentWidget, { key: 'contentWidget' });
  }
}
